import { message, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useCreateCategory from '@/hooks/adminTecdoc/useCreateCategory';
import api from '@/services/api';
const CreateMainCategory = ({ show, onCancel, onCreate, parentId }) => {
    const siteSettings = useSelector(e => e?.settings);
    const { t } = useTranslation();
    const createCategory = useCreateCategory();

    const [loadingLanguages, setLoadingLanguages] = useState(false);
    const [languagesData, setLanguagesData] = useState([]);

    const [form] = Form.useForm();

    useEffect(() => {
        fetchLanguages();
    }, []);

    const fetchLanguages = () => {
        setLoadingLanguages(true);
        api()({
            url: '/webshop/management/languages',
            method: 'GET'
        }).then(e => {
            const activeLangs = e?.data?.filter(x => x.Active) || [];
            setLanguagesData(activeLangs);
        }).catch(f => {
            message.error(f?.response?.data?.message || "Error fetching languages");
        }).finally(() => {
            setLoadingLanguages(false);
        });
    };

    const onFinishForm = () => {
        form.validateFields().then(values => {
            // values: { categoryName_EN: '...', categoryName_NL: '...' }
            const categoryName = {};

            languagesData.forEach(lang => {
                categoryName[lang.Code] = values[`categoryName_${lang.Code}`];
            });


            createCategory.create(categoryName, parentId).then(e => {
                console.log({e});
                onCreate && onCreate(e);
            }).catch(f => {
                message.error(f?.response?.data?.message || "Error");
            });
        }).catch(f => {
            message.error("Validation error");
        }).finally(() => {
           
        });
    };

    return (
        <Modal
            loading={createCategory.loading}
            title={t('create-category')}
            onOk={onFinishForm}
            okButtonProps={{ loading: createCategory.loading }}
            okText={t('save')}
            cancelButtonProps={{ style: { display: 'none' } }}
            open={show}
            onCancel={onCancel}
        >
            <Form
                form={form}
                name="create-category-form"
                autoComplete="off"
                layout='vertical'
            >
                {languagesData.map(lang => (
                    <Form.Item
                        key={lang.Code}
                        label={`${t('category-name')} (${lang.Name})`}
                        name={`categoryName_${lang.Code}`}
                        rules={[{ required: true, message: t('please-input') }]}
                    >
                        <Input placeholder={`${t('category-name')} (${lang.Name})`} />
                    </Form.Item>
                ))}
            </Form>
        </Modal>
    );
};

export default CreateMainCategory;
